export const colors = [
  // "#7B8869",
  // "#818F6E",
  // "#879673",
  // "#8C9D77",
  // "#90A37B",
  // "#A7B691",
  // "#D4DCBD",
  // "#DDE3CA",
  // "#E4E9D5",
  '#BDC9A7',
  '#ffd700',
  'purple',
  'blue',
  'silver',
  'green',
  '#7FB375',
  'yellow',
  'orange',
  'red',
]

export const segmentationPalette = [
  '#ffd700',
  'purple',
  'blue',
  'silver',
  'green',
  '#7FB375',
  'yellow',
  'orange',
  'red',
  '#909E7C',
]

export const chartDefaultColors = [
  '#6295F9',
  '#6CDAAB',
  '#657798',
  '#F2C01B',
  '#7666FA',
  '#72CAED',
  '#90A37B',
  'purple',
  'blue',
  'silver',
  'green',
  '#7FB375',
  'yellow',
  'orange',
  'red',
  '#909E7C',
]

export const responseRatePalette = ['#909E7C', '#70AC20', '#46B25E', '#45A594']

export const conditionBasedPalette = [
  '#297B9Eff',
  '#FFCE5Dff',
  '#5EBEA9ff',
  '#C5309Dff',
  '#F19898ff',
  '#031523ff',
]
